import { BULK_OPERATION_STATUS, BULK_OPERATION_TYPE } from "./constants"

export const BULK_OPERATION_MESSAGES = {
    [BULK_OPERATION_TYPE.CREATE_ACCOUNT_STATEMENT]: {
        id: "bulk.operations.orders_operation_type_account_statements_creation",
        defaultMessage: "Create Account Statement",
    },
    [BULK_OPERATION_TYPE.CONTACT_UPDATE]: {
        id: "bulk.operations.orders_operation_type_contacts_updates",
        defaultMessage: "Update",
    },
    [BULK_OPERATION_TYPE.APPLY_INVOICE_PAYMENT]: {
        id: "bulk.operations.operation_type_apply_invoice_payments",
        defaultMessage: "Apply Payment",
    },
    [BULK_OPERATION_TYPE.EDIT_INVOICE_LOCATION]: {
        id: "bulk.operations.operation_type_edit_invoices_location",
        defaultMessage: "Edit invoices location",
    },
    [BULK_OPERATION_TYPE.EDIT_CREDIT_MEMO_LOCATION]: {
        id: "bulk.operations.operation_type_edit_credit_memos_location",
        defaultMessage: "Edit credit memos location",
    },
    [BULK_OPERATION_TYPE.APPLY_PRICE_LIST_PAYMENT]: {
        id: "bulk.operations.orders_operation_type_apply_price_list_payment",
        defaultMessage: "Apply Payment",
    },
    [BULK_OPERATION_TYPE.PRICE_LIST_CREATE_ORDER]: {
        id: "bulk.operations.orders_operation_type_price_list_bulk_create_orders",
        defaultMessage: "Create Order",
    },
    [BULK_OPERATION_TYPE.SEND_EMAIL]: {
        id: "bulk.operations.operation_type_send_email",
        defaultMessage: "Send Email",
    },
    [BULK_OPERATION_TYPE.ORDER_STATUS_UPDATE]: {
        id: "bulk.operations.orders_operation_type_orders_update_status",
        defaultMessage: "Update Status",
    },
    [BULK_OPERATION_TYPE.DELETE]: {
        id: "bulk.operations.orders_operation_type_delete",
        defaultMessage: "Delete",
    },
    [BULK_OPERATION_TYPE.PRINT_INVOICE]: {
        id: "bulk.operations.print_invoices",
        defaultMessage: "Prepare to Print",
    },
    [BULK_OPERATION_TYPE.EXPORT]: {
        id: "bulk.operations.bulk_export",
        defaultMessage: "Export",
    }
}

export const BULK_OPERATION_STATUS_MESSAGES = {
    [BULK_OPERATION_STATUS.RUNNING]: {
        id: "bulk.modal.operations.orders_status_running",
        defaultMessage: "Running",
    },
    [BULK_OPERATION_STATUS.COLLECTING]: {
        id: "bulk.modal.operations.orders_status_collecting",
        defaultMessage: "Collecting",
    },
    [BULK_OPERATION_STATUS.COMPLETED]: {
        id: "bulk.modal.operations.orders_status_completed",
        defaultMessage: "Completed",
    },
    [BULK_OPERATION_STATUS.CREATED]: {
        id: "bulk.modal.operations.orders_status_created",
        defaultMessage: "Created",
    },
    [BULK_OPERATION_STATUS.ERROR]: {
        id: "bulk.modal.operations.orders_status_error",
        defaultMessage: "Error",
    },
    [BULK_OPERATION_STATUS.ABORTED]: {
        id: "bulk.modal.operations.orders_status_aborted",
        defaultMessage: "Aborted",
    },
}


// WEBPACK FOOTER //
// ./src/utils/automation/bulk/message.ts